import { observer } from 'mobx-react-lite'
import { useState } from 'react'
import { SortableEditorListItem } from '@/features/legends/components/EditorList'
import type { EffectEditorViewModel } from '@/features/legends/effects/EffectEditorViewModel'
import { EffectEditor } from '@/features/legends/effects/components/EffectEditor'
import { MutatorEditorContainer } from '@/features/legends/effects/components/MutatorEditorContainer'
import { mutatorTypes } from '@/features/legends/effects/mutator-registry'

export interface EffectEditorContainerProps {
  vm: EffectEditorViewModel
  /**
   * The ID of the effect descriptor the effect is shown under; a select
   * question's own effect has the question's ID.
   */
  descriptorId: string
  testId?: string
}

export const EffectEditorContainer = observer(function EffectEditorContainer({
  vm,
  descriptorId,
  testId,
}: EffectEditorContainerProps) {
  // Several effects can be expanded at once, like a Yes/No's Yes and No.
  const [mutatorGroup] = useState(() => Symbol('mutator'))
  const hasServiceItemAmount = vm.hasServiceItemAmount(descriptorId)
  return (
    <EffectEditor
      mutatorTypes={vm.getAvailableMutatorTypes(descriptorId)}
      onAdd={vm.mutators.add}
      isDisabled={vm.mutators.isEditingDisabled}
      testId={testId}
    >
      {vm.mutators.mutators.map((mutatorVm, i) => (
        <SortableEditorListItem
          key={mutatorVm.cid}
          group={mutatorGroup}
          index={i}
          onMove={vm.mutators.moveByIndex}
          isDisabled={vm.mutators.isEditingDisabled}
          label={mutatorTypes[mutatorVm.type].title}
          onRemove={() => vm.mutators.remove(mutatorVm)}
          testId={testId && `${testId}-mutator-${i}`}
        >
          <MutatorEditorContainer
            vm={mutatorVm}
            hasServiceItemAmount={hasServiceItemAmount}
            testId={testId && `${testId}-mutator-${i}-fields`}
          />
        </SortableEditorListItem>
      ))}
    </EffectEditor>
  )
})
